import { Box } from '@mui/material'
import { Stack } from '@mui/system'
import { FeatureFlagIdProvisioningDrawer } from 'c1gen/features'
import { C1Button } from 'c1ui'
import { C1DrawerInner } from 'components/core/drawer/C1DrawerInner'
import { useFeatureChecker } from 'components/no-ui/capability'
import { C1EntitlementDisplayName } from 'components/pages/entitlement/display-name'
import { ManageProvisioningEntitlementsList } from 'components/pages/requestcatalog/details/setup/ManageProvisioningEntitlementsList'
import { ManageProvisioningStyles } from 'components/pages/requestcatalog/details/setup/styles'
import { AppEntitlementValue } from 'lib/actions/apps/app-entitlement'
import { FC, useCallback } from 'react'
import { FormattedMessage } from 'react-intl'

type ManageProvisioningDrawerProps = {
    closeDrawer: () => void
    setCanClose: (canClose: boolean) => void
    title: string
    catalogId: string
    entitlement: AppEntitlementValue
}

export const ManageProvisioningDrawer: FC<ManageProvisioningDrawerProps> = ({
    closeDrawer,
    setCanClose,
    title,
    catalogId,
    entitlement,
}) => {
    const hasProvisioningDrawerFF = useFeatureChecker(FeatureFlagIdProvisioningDrawer)

    const onCancel = useCallback((): void => {
        setCanClose(true)
        closeDrawer()
    }, [closeDrawer, setCanClose])

    if (!hasProvisioningDrawerFF) {
        return null
    }

    return <C1DrawerInner>
        <C1DrawerInner.Header>
            {title}
        </C1DrawerInner.Header>

        <C1DrawerInner.Content>
            <Stack spacing={3} width="100%">
                <Box p={2} sx={ManageProvisioningStyles.rectangle} flexWrap="wrap">
                    <C1EntitlementDisplayName
                        entitlement={entitlement}
                        readOnly
                    />
                </Box>
                <Box>
                    <ManageProvisioningEntitlementsList catalogId={catalogId} appEntitlementValue={entitlement} showPending />
                </Box>
            </Stack>
        </C1DrawerInner.Content>

        <C1DrawerInner.Footer>
            <C1Button variant="outlined" onClick={onCancel}>
                <FormattedMessage defaultMessage="Go back" id="components_sample_edit_drawer_cancel" />
            </C1Button>
        </C1DrawerInner.Footer>
    </C1DrawerInner>
}
